var _path, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 188,
    viewBox: "0 0 159 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 0C26.871 0 1.71956 29.6509 0.671333 30.914C0.238366 31.4432 0.0012955 32.105 0 32.7881L0 91.8548C0 141.815 46.0864 171.478 65.8967 181.912C66.5827 182.229 67.3645 182.271 68.0808 182.03C68.7971 181.788 69.3932 181.282 69.746 180.615C70.0988 179.948 70.1815 179.171 69.977 178.445C69.7724 177.719 69.2963 177.099 68.6468 176.713C45.209 164.369 5.88889 136.933 5.88889 91.8489V33.9043C10.0229 29.4687 33.1662 6.89719 76.5556 5.9102V185.061C76.5552 185.658 76.7371 186.24 77.077 186.732C77.4169 187.223 77.8987 187.599 78.4582 187.81C79.0177 188.021 79.6285 188.057 80.2091 187.914C80.7897 187.77 81.3127 187.453 81.7083 187.005C91.3484 182.87 159 151.668 159 91.0617V32.3122C159 31.6279 158.76 30.965 158.323 30.4381C157.451 29.3865 136.451 4.73521 92.7147 0.334872C91.9395 0.265491 91.168 0.50139 90.5649 0.992134C89.9619 1.48288 89.5752 2.18952 89.4876 2.96097C89.4485 3.34481 89.4855 3.73257 89.5967 4.1021C89.7078 4.47164 89.8908 4.81571 90.1353 5.11468C90.3797 5.41364 90.6808 5.66164 91.0213 5.84451C91.3618 6.02737 91.7351 6.14153 92.1199 6.18045C129.143 9.90516 149.26 29.3571 153.111 33.4402V91.0617C153.111 143.654 97.9734 173.011 82.4444 180.238V2.93747C82.4444 2.15841 82.1342 1.41125 81.582 0.860366C81.0298 0.309483 80.2809 0 79.5 0Z",
    fill: "url(#paint0_linear_13000_502279)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 89,
    r: 62,
    fill: "url(#paint1_linear_13000_502279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13000_502279",
    x1: 9.5,
    y1: 5.5,
    x2: 136,
    y2: 177.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13000_502279",
    x1: 25.4088,
    y1: 30.6277,
    x2: 103.81,
    y2: 156.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldGray);
export default __webpack_public_path__ + "static/media/shield-gray.30e0fef869225958fc84e77816687a71.svg";
export { ForwardRef as ReactComponent };